module.exports = __webpack_public_path__ + "img/resda-back.e8dce7eb.svg";